import { oc } from '@orpc/contract';
import { changeVehicleStatusInputSchema, vehicleDetailSchema } from '../schemas/vehicles.schemas.js';
/**
 * `IN_WAREHOUSE ⇄ IN_SERVICE → SOLD` (plan §5.6).
 *
 * The rule runs **inside the transaction**, on the row it has just locked: a note for a move between the
 * warehouse and the workshop, and for a sale a price, a date and a buyer — with a price below the
 * required retail reserved to an administrator, who has to say why. `SOLD` is closed: it has no
 * transitions of its own and every other mutation is refused from that moment on.
 */
export const changeVehicleStatusContract = oc
    .route({
    method: 'POST',
    path: '/vehicles/{vehicleId}/status',
    tags: ['Vehicles'],
    summary: 'Move a stock vehicle between warehouse, service and sold',
})
    .input(changeVehicleStatusInputSchema)
    .output(vehicleDetailSchema);
//# sourceMappingURL=change-vehicle-status.contract.js.map